@if (!showOtpScreen && showTnc) {
  <div class="tnc-container">
    <div class="header">
      <img alt="back" (click)="goBack()" src="assets/svg/icons/black-arrow-left.svg" class="back-icon">
      <h2 class="header-title">Accept Terms &amp; Conditions</h2>
    </div>
    <div class="main-content" #scrollContainer (scroll)="onScroll($event)">
      <h2 class="main-content-title">Terms &amp; Conditions</h2>
      <div class="content-container">
        <h2 class="content-container-heading">Consent For</h2>
        <p class="content">Co-branded Wallet Account Creation</p>
        <p class="content"><span class="bold-text">Dear User,</span><br>
        You’re about to open a secure digital wallet issued by <span class="bold-text">EnKash (Nehat Tech Solutions Pvt.
      Ltd.),</span>
      an RBI-authorised <span class="bold-text">Prepaid Payment Instrument (PPI) issuer,</span> in partnership under a
      <span class="bold-text">Cobranded Partner arrangement.</span>
    </p>
  </div>
  <div class="content-container">
    <h2 class="content-container-heading">By proceeding, you consent to</h2>
    <ul class="content bullet-list">
      <li>Open a wallet issued by EnKash via the Cobranded Partner arrangement</li>
      <li>Share your basic KYC details (Name, PAN, KYC Status) for account setup</li>
      <li>Allow both parties to securely process and store your data for regulatory compliance</li>
      <li>Manage wallet transactions and notifications through the Cobranded Partner’s app</li>
    </ul>
  </div>
  <div class="content-container">
    <h2 class="content-container-heading">Why This Matters</h2>
    <ul class="content bullet-list">
      <li>Fast, secure digital payments</li>
      <li>Instant wallet access with KYC-based limits</li>
      <li>Fully regulated, RBI-compliant wallet service</li>
    </ul>
  </div>
  <div class="content-container">
    <h2 class="content-container-heading">Data Privacy &amp; Security</h2>
    <ul class="content bullet-list">
      <li>Wallet opened by EnKash under Cobranded Partner arrangement</li>
      <li>Personal and transaction data encrypted per RBI norms</li>
      <li>Data shared only for wallet creation, operation, and compliance</li>
      <li>You’ll receive important wallet updates and notifications</li>
    </ul>
  </div>
  <div class="content-container">
    <h2 class="content-container-heading">View EnKash’s PPI Terms &amp; Conditions:</h2>
    <p class="content" style="font-weight: 500; color: #1B5AF4; text-decoration: underline;">
      <a href="https://home.enkash.com/tnc-ppi" target="_blank">
        PPI Terms & Conditions
      </a>
    </p>
  </div>
  <div class="content-container">
    <h2 class="content-container-heading">Please confirm your consent to open a new wallet account.</h2>
    <p class="content">By proceeding, you confirm that you have read and accept the Terms &amp; Conditions</p>
  </div>
</div>
<div class="tnc-footer">
  <button type="button" class="footer-btn cancel" (click)="goToTnc()">
    Cancel
  </button>
  <button type="button" class="footer-btn agree" (click)="onAgreeClick()">
    Agree
  </button>
</div>
</div>
}

<!-- MOBILE OTP SCREEN -->
@if (showOtpScreen) {
  <div class="tnc-mobile-container">
    <div class="mobile-header">
      <img alt="back" (click)="goToTnc()" src="assets/svg/icons/black-arrow-left.svg" class="back-icon">
    </div>
    <div class="mobile-main-content">
      <div class="verification-container">
        <div class="verification-title">Enter OTP sent to</div>
        <div class="verification-subtitle">+91 {{ mobileNumber }}</div>
        @if (otpVisible) {
          <ngx-otp-input [config]="otpInputConfig" [key]="otpInputKey"
            (otpChange)="onMobileOtpChange($event)" autocomplete="one-time-code">
          </ngx-otp-input>
        }
        <div class="otp-actions">
          <a class="resend-msg">Didn’t receive an OTP?</a>
          @if (resendOTPStatus) {
            <div class="resend-timer">
            00:{{ timeLeft < 10 ? '0' + timeLeft : timeLeft }}s </div>
          }
          @if (!resendOTPStatus) {
            <a class="switch-mode-btn" (click)="resendOtp()">
              Resend OTP
            </a>
          }
        </div>
      </div>
    </div>
    <div class="mobile-footer">
      <button class="verify-btn" (click)="verifyOtp()">
        Verify
      </button>
    </div>
  </div>
}


<ng-template #otpModal>
  <div class="modal-wrapper">
    <div class="otp-header">
      <div class="otp-header-title">
        <div class="header-left">
          <img src="assets/svg/icons/lock-icon.svg" alt="Enter Otp" />
          <h2 class="otp-heading">Enter OTP</h2>
        </div>
        <div class="close-btn">
          <img src="assets/svg/icons/close-modal.svg" style="cursor: pointer !important;" alt="close"
            (click)="closeInfoModal()" />
        </div>
      </div>

      <div class="otp-header-subtitle">
        <span class="otp-subheading">Enter the OTP sent on your Mobile Number</span>
        <span class="otp-subheading" style="color: #1B5AF4;">Mobile Number +91 {{ mobileNumber }}</span>
      </div>
    </div>

    <div class="otp-body">
      <div class="otp-input-wrapper">
        <input type="text" [value]="otpControl.value" (input)="onOtpChange($event)" placeholder="Enter here"
          class="otp-input" />
      </div>
      @if (resendOTPStatus) {
        <div class="otp-resend">
          You can resend OTP after <span class="red-text">00:{{ timeLeft < 10 ? '0' + timeLeft : timeLeft }}s</span>
        </div>
      }
      @if (!resendOTPStatus) {
        <div class="resend-link" (click)="resendOtp()">
          Resend OTP
        </div>
      }
    </div>

    <div class="otp-footer">
      <button class="btn-cancel" (click)="closeInfoModal()">Cancel</button>
      <button class="btn-verify" (click)="verifyOtp()" [appLoaderButton]="verifyOtpPending.state">Verify</button>
    </div>
  </div>
</ng-template>